/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Avatar,
  Box,
  Button,
  Flex,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { HiLink } from "react-icons/hi";
import { MdOutlineClose } from "react-icons/md";
import { TiDelete } from "react-icons/ti";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../Context/AuthProvider";
import { useDropdownOptions } from "../../hooks/useDropdownOptions";
import LoadingSpinner from "../../LoadingSpinner";
import apiClient from "../../utils/ApiClient/apiClientAxios";
import { toastService } from "../../utils/ApiClient/toastService";
import CustomModal from "../Common/CustomModal/CustomModal";
import AsignCase from "./AsignCase";
import DeduplicationSummary from "./DeduplicationStatus";
import DeduplicationLink from "./DuplicateCheckLink";
import EdssQuickLInks from "./EdssQuickLInks";
import ViewAllAddress from "./ViewAllAddress";

const UserInfoPanel = ({
  userInfo,
  data,
  isFetchingPerson,
  fetchEdssCase,
  edssData,
  setEdssData,
  setFormState,
}) => {
  const { isAuthenticated, isAdmin } = useContext(AuthContext);
  const [selectedUserAddress, setSelectedUserAddress] = useState(null);
  const [user, setUser] = useState(() => {
    const storedData = localStorage.getItem("recentClickCase");
    return storedData ? JSON.parse(storedData) : null;
  });
  const { onOpen, isOpen, onClose } = useDisclosure();
  const {
    onOpen: onAddressViewOpen,
    isOpen: isAddressViewOpen,
    onClose: onAddressViewClose,
  } = useDisclosure();
  const navigate = useNavigate();
  const { id, personID } = useParams();
  const location = useLocation();
  const { options: raceOptions, isLoading: isRaceLoading } =
    useDropdownOptions("RACE");
  const {
    options: tribeOptions,
    isLoading: isJURISDICTIONAL_ASSIGNMENTLoading,
  } = useDropdownOptions("JURISDICTIONAL_ASSIGNMENT");
  const { options: caseTypeOptions, isLoading: iscaseTypeOptionsRaceLoading } =
    useDropdownOptions("CASE_TYPE");

  useEffect(() => {
    const handleStorageChange = () => {
      const storedData = localStorage.getItem("recentClickCase");
      setUser(storedData ? JSON.parse(storedData) : null);
    };

    window.addEventListener("storage", handleStorageChange);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "recentClickCase") handleStorageChange();
    };

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const updateCaseField = async (fieldKey, fieldValue) => {
    const payload = {
      id,
      PERSON_ID: personID,
      ADMINISTRATIVE: {
        [fieldKey]: fieldValue,
      },
    };

    try {
      const response = await apiClient.post("/saveEDSSCase", payload);
      const responseData = response.data;
      if (response.status === 200) {
        toastService.success(responseData);
        fetchEdssCase(id, personID);
      } else {
        toastService.error(responseData || "Something went wrong!");
      }
    } catch (err) {
      console.error("API error:", err);
    }
  };

  const handleRemovedAssigned = () => updateCaseField("ASSIGNED_USER", "");
  const handleRemovedAssignedCase = () => updateCaseField("CLOSED_DATE", "");
  const handleAddClosedDate = () =>
    updateCaseField("CLOSED_DATE", new Date().toISOString());

  const { BIRTH_DATE, FIRST_NAME, GENDER, LAST_NAME, DEDUPLICATION } = userInfo;
  const { CITY, STREET_1, STREET_2, TELEPHONE_HOME, STATE, ZIP } =
    userInfo?.ADDRESS?.[0] || {};

  const handlePickedAddreess = () => {
    const allowedFields = [
      "STATE",
      "STREET_1",
      "STREET_2",
      "CITY",
      "ZIP",
      "COUNTY",
      "COUNTRY",
    ];
    const newFormState = {};

    Object.entries(selectedUserAddress).forEach(([key, val]) => {
      if (allowedFields.includes(key)) {
        const fieldKey = key === "COUNTY" ? "COUNTY_DESC" : key;
        newFormState[fieldKey] = val;
      }
    });

    // Only update formState
    setFormState((prev) => ({
      ...prev,
      CONTACT: {
        ...(prev.CONTACT || {}),
        ...newFormState,
      },
    }));

    navigate(`${location.pathname}?tab=CONTACT`);
    onAddressViewClose();
    setSelectedUserAddress(null);
  };

  if (isFetchingPerson) return <LoadingSpinner />;

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        gap={2}
        cursor="pointer"
        onClick={() => navigate("/Investigate")}
      >
        <MdOutlineClose />
        <Text>Close</Text>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDir="column"
        mt={1}
      >
        <Avatar size="md" name={`${FIRST_NAME} ${LAST_NAME}`} />
        <Link to={`/personview/${personID}`}>
          <Text
            fontWeight={500}
            fontSize="xl"
            mt={2}
            color="#2b6cb0"
            _hover={{ textDecoration: "underline" }}
            display="flex"
            alignItems="center"
            gap={1}
          >
            {FIRST_NAME} {LAST_NAME}
            <HiLink fontSize="18px" color="#2b6cb0" />
          </Text>
        </Link>
        {isAuthenticated && isAdmin && (
          <DeduplicationLink
            personID={personID}
            DEDUPLICATION={DEDUPLICATION}
            isAdmin={isAdmin}
          />
        )}
      </Box>

      <Box my={2}>
        <Box textAlign="center" p={1} bg="bgColor" color="white">
          Personal Information
        </Box>
      </Box>

      <Flex flexDir="column" justifyContent="space-between" gap={1}>
        <Box>
          <InfoRow label="Name" value={`${FIRST_NAME} ${LAST_NAME}`} />
          <InfoRow
            label="Birth Date"
            value={
              BIRTH_DATE ? moment(BIRTH_DATE).format("MMM D, YYYY") : "N/A"
            }
          />
          <InfoRow label="Gender" value={GENDER === "F" ? "Female" : "Male"} />
          <InfoRow
            label="Condition"
            value={(() => {
              const productValue =
                edssData?.ADMINISTRATIVE?.FIELDS?.PRODUCT?.VALUE;
              if (iscaseTypeOptionsRaceLoading) return "Loading...";
              if (!caseTypeOptions || caseTypeOptions.length === 0)
                return "N/A";
              const found = caseTypeOptions.find(
                (option) => option.value === productValue,
              );
              return found?.label || productValue || "N/A";
            })()}
          />
          {userInfo?.RACE?.length > 0 && (
            <InfoRow label="Race">
              <Text fontSize="sm">
                {userInfo.RACE.map(
                  (r) => raceOptions.find((o) => o.value === r)?.label || r,
                ).join(", ")}
              </Text>
            </InfoRow>
          )}
          {userInfo?.TRIBE?.length > 0 && (
            <InfoRow label="Tribe">
              <Text fontSize="sm">
                {userInfo.TRIBE.map(
                  (t) => tribeOptions.find((o) => o.value === t)?.label || t,
                ).join(", ")}
              </Text>
            </InfoRow>
          )}
          <InfoRow label="Closed Date">
            <Box>
              {data?.ADMINISTRATIVE?.FIELDS?.CLOSED_DATE?.VALUE ? (
                <Flex alignItems="center" justifyContent="space-evenly">
                  <Text textAlign="center" fontSize="xs">
                    {moment(
                      data.ADMINISTRATIVE.FIELDS.CLOSED_DATE.VALUE,
                    ).format("YYYY-MM-DD HH:mm:ss")}
                  </Text>
                  <TiDelete
                    cursor="pointer"
                    fontSize="20px"
                    onClick={handleRemovedAssignedCase}
                  />
                </Flex>
              ) : (
                <Text
                  onClick={handleAddClosedDate}
                  cursor="pointer"
                  color="blue.500"
                >
                  Close Case
                </Text>
              )}
            </Box>
          </InfoRow>
          {isAdmin && isAuthenticated && (
            <InfoRow label="Case Dedup">
              {data?.ADMINISTRATIVE?.FIELDS?.DEDUPLICATION && (
                <DeduplicationSummary
                  dedupSchema={data?.ADMINISTRATIVE.FIELDS.DEDUPLICATION}
                  isAdmin={isAdmin}
                />
              )}
            </InfoRow>
          )}
        </Box>

        {userInfo?.ADDRESS?.[0] && (
          <Box>
            <Box
              textAlign="center"
              p={1}
              borderBottom="2px solid gray"
              color="black"
              fontWeight={500}
              display="flex"
              alignItems="center"
              gap={2}
            >
              <Text>Current Address</Text>
            </Box>
            <Box px={1} py={2}>
              <Text fontSize="sm">
                {STREET_1} {STREET_2}
              </Text>
              <Text fontSize="sm">
                {CITY}, {STATE} {ZIP}
              </Text>
              {TELEPHONE_HOME && (
                <Text fontSize="sm">Phone: {TELEPHONE_HOME}</Text>
              )}

              <Button
                onClick={() => onAddressViewOpen()}
                size="xs"
                colorScheme="blue"
                variant="link"
                bg="none"
                border="none"
              >
                Choose Morbidity Address
              </Button>
            </Box>
          </Box>
        )}

        <Box>
          <Box
            textAlign="center"
            p={1}
            borderBottom="2px solid gray"
            color="black"
            fontWeight={500}
          >
            Assigned Case
          </Box>
          <Box>
            {data?.ADMINISTRATIVE?.FIELDS?.ASSIGNED_USER?.VALUE ? (
              <Flex alignItems="center" justifyContent="space-evenly">
                <Text textAlign="center">
                  {data.ADMINISTRATIVE.FIELDS.ASSIGNED_USER.VALUE}
                </Text>
                <TiDelete
                  cursor="pointer"
                  fontSize="20px"
                  onClick={handleRemovedAssigned}
                />
              </Flex>
            ) : (
              <Button
                mt={1}
                textAlign="center"
                onClick={onOpen}
                w="100%"
                size="xs"
                _hover={{ bg: "bgColor", color: "white" }}
              >
                Assign
              </Button>
            )}
          </Box>
        </Box>

        <Box>
          <Box
            textAlign="center"
            p={1}
            borderBottom="2px solid gray"
            color="black"
            fontWeight={500}
          >
            Quick links
          </Box>
          <EdssQuickLInks user={user} info={{ id, person: personID }} />
        </Box>
      </Flex>

      <CustomModal
        size="4xl"
        title="Assign case"
        isOpen={isOpen}
        onClose={onClose}
        bodyContent={
          <AsignCase
            data={data}
            fetchEdssCase={fetchEdssCase}
            onClose={onClose}
          />
        }
      />
      <CustomModal
        size="6xl"
        title="Select Address"
        isOpen={isAddressViewOpen}
        onClose={onAddressViewClose}
        bodyContent={
          <ViewAllAddress
            data={userInfo?.ADDRESS}
            onSelect={(selectedAddress) => {
              setSelectedUserAddress(selectedAddress);
            }}
          />
        }
        footerContent={
          <Button
            onClick={handlePickedAddreess}
            size="sm"
            isDisabled={!selectedUserAddress}
          >
            Select Address
          </Button>
        }
      />
    </Box>
  );
};

export default UserInfoPanel;

// === Reusable Info Row ===
const InfoRow = ({ label, value, children }) => (
  <Flex justifyContent="space-evenly" fontSize="sm" mb={1}>
    <Box textAlign="left" w="50%" fontSize="xs">
      {label}
    </Box>
    <Box textAlign="center"> : </Box>
    <Box textAlign="left" width="50%" ml={1} fontSize="xs">
      {children || <Text fontSize="xs">{value}</Text>}
    </Box>
  </Flex>
);
